<li class="issue">
    <div class="issue__username">{{username}}</div>
    <div class="issue__desc">{{issue}}</div>
</li>
